import { DocumentationPageV1, PageBlockV1 } from "@supernova-studio/model";
import { z } from "zod";
import { DTODocumentationItemConfigurationV1 } from "./item-configuration-v1";

//
// Read
//

export const DocumentationPageV1DTO = DocumentationPageV1.omit({
  data: true,
  meta: true,
  parentPersistentId: true,
  sortOrder: true,
}).extend({
  configuration: DTODocumentationItemConfigurationV1,
  blocks: z.array(PageBlockV1),
  title: z.string(),
  path: z.string(),
});

export type DocumentationPageV1DTO = z.infer<typeof DocumentationPageV1DTO>;
